
import { supabase } from "@/integrations/supabase/client";
import { QueryResult } from "../types";

/**
 * Queries related to contract statistics
 */
export const contractStatsQueries = {
  // Get user contract statistics
  getUserContractStats: async (year?: number): Promise<QueryResult> => {
    try {
      const currentYear = year || new Date().getFullYear();
      const startOfYear = new Date(currentYear, 0, 1).toISOString();
      const endOfYear = new Date(currentYear, 11, 31, 23, 59, 59).toISOString();
      
      // Today's date for active/expiring calculations
      const today = new Date().toISOString().split('T')[0];
      
      // Thirty days from now for expiring calculations
      const thirtyDaysFromNow = new Date();
      thirtyDaysFromNow.setDate(thirtyDaysFromNow.getDate() + 30);
      const thirtyDaysFromNowStr = thirtyDaysFromNow.toISOString().split('T')[0];
      
      // Get total contracts count
      const { count: totalContracts, error: totalError } = await supabase
        .from('contracts')
        .select('*', { count: 'exact', head: true })
        .gte('created_at', startOfYear)
        .lte('created_at', endOfYear);
      
      if (totalError) throw totalError;
      
      // Get active contracts (not expired)
      const { count: activeContracts, error: activeError } = await supabase
        .from('contracts')
        .select('*', { count: 'exact', head: true })
        .gte('expiry_date', today)
        .gte('created_at', startOfYear)
        .lte('created_at', endOfYear);
      
      if (activeError) throw activeError;
      
      // Get expiring contracts (in next 30 days)
      const { count: expiringContracts, error: expiringError } = await supabase
        .from('contracts')
        .select('*', { count: 'exact', head: true })
        .gte('expiry_date', today)
        .lte('expiry_date', thirtyDaysFromNowStr)
        .gte('created_at', startOfYear)
        .lte('created_at', endOfYear);
      
      if (expiringError) throw expiringError;
      
      return {
        data: {
          totalContracts: totalContracts || 0,
          activeContracts: activeContracts || 0,
          expiringContracts: expiringContracts || 0
        },
        error: null
      };
    } catch (error) {
      console.error("Error fetching user contract stats:", error);
      return {
        data: {
          totalContracts: 0,
          activeContracts: 0,
          expiringContracts: 0
        },
        error
      };
    }
  }
};
